<script>
  import { createNamespacedHelpers } from 'vuex';

  const { mapGetters, mapActions } = createNamespacedHelpers('hitch');

  export default {
    name: 'CustomOptions',
    props: {
      variant: {
        /** The currently selected frame variant */
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters([
        'getBaseProducts',
        'getSelectedBaseProduct',
        'getCustomizationStyle',
        'getAllCustomizationStyles',
        'getCustomizationStyle'
      ]),
    },
    methods: {
      selectBase() {
        /**
         * this will be for products that have multiple frames
         * with same implementation as below
         */
      },
      selectVariant(index) {
        /**
         * this will follow same implementation of selectLetterStyle
         * for variants
         */
        this.$store.dispatch('hitch/selectBaseVariant', index);
      },
      ...mapActions([
        'selectCustomizationStyle'
      ])
    },
  };
</script>

<template>
  <div class="letter-edit x-type--wrap">

    <div class="letter-edit__wrap">

      <div v-if="getAllCustomizationStyles.length > 1" class="letter-edit__radios">
        <label class="letter-edit__radios__heading">Customization Style</label>
        <div class="letter-edit__radios__inputs">
          <div v-for="(style, index) in getAllCustomizationStyles" :key="index" class="letter-edit__radios__input">
            <input
              :id="`customizationStyle_${index}`"
              type="radio"
              name="customizationStyle"
              :value="style.value"
              :checked="getCustomizationStyle.value === style.value"
              @change="selectCustomizationStyle(style)"
            />
            <label :for="`customizationStyle_${index}`">{{ style.label }}</label>
          </div>
        </div>
      </div>

      <div v-if="getBaseProducts.length > 1" class="letter-edit__colors js-custom-plate__frame-types">
        <label class="letter-edit__label">
          Type: <span class="js-custom-plate__frame-type-label">{{ getSelectedBaseProduct.name }}</span>
        </label>

        <div v-for="type in getBaseProducts" :key="type.id" class="letter-edit__color m-frame">
          <input
            type="radio"
            class="js-custom-plate__frame-type-radio"
            name="frame-type"
            :checked="getSelectedBaseProduct.id === type.id"
            @click="selectBase(type)"
            :id="'base_' + type.id"
            :value="type.id"
          />
          <label
            :for="'base_' + type.id"
            :style="{ backgroundImage: 'url(' + type.image + ')' }"
          >
            <span></span>
            {{ type.name }}
          </label>
        </div>
      </div>

      <div class="letter-edit__colors js-custom-plate__frame-colors">
        <label class="letter-edit__label">
          Hitch Cover Color: <span class="js-custom-plate__frame-colors-label">{{ variant.finish.label }}</span>
        </label>

        <div
          v-for="(style, index) in getSelectedBaseProduct.variants"
          :key="style.id"
          :class="'letter-edit__color m-swatch-' + style.finish.brightness"
        >
          <input
            type="radio"
            name="frame-color"
            @click="selectVariant(index)"
            :id="'color_' + style.finish.id"
            :checked="variant.id === style.id"
            :value="style.finish.id"
          />
          <label :for="'color_' + style.finish.id" :style="{ backgroundImage: 'url(' + style.finish.swatch + ')',}">
            {{ style.finish.label }}
          </label>
        </div>
      </div>

    </div>

  </div>
</template>
